import { StackedGroupBarChart } from "@jana-technology/platform-ui";

import { useGlobalFiltersContext } from "contexts/filters/global-filters";
import { useBaseBarChartProps } from "hooks/useBaseBarChartProps";
import { useSystemOverviewTotalCharts } from "hooks/queries";
import { x1Accessor, xAccessor } from "helpers/charts";

import { ChartCard } from "components/charts/ChartCard";
import { TopRiskWellsByThreatIntervention } from "components/charts/TopRiskWellsIntervention";
import { InterventionCardHeading } from "components/headings";
import { ChartsLayout } from "layouts/ChartsLayout";

export const SystemOverviewInterventionCharts = () => {
  const { hierarchyIdsOverview } = useGlobalFiltersContext();

  const systemOverviewTotalCharts = useSystemOverviewTotalCharts({
    variables: { hierarchyIds: hierarchyIdsOverview },
  });

  const baseBarChartProps = useBaseBarChartProps();

  return (
    <ChartsLayout>
      <ChartCard
        loading={systemOverviewTotalCharts.loading}
        heading={<InterventionCardHeading heading="Risk by Threat" />}
      >
        <StackedGroupBarChart
          {...baseBarChartProps}
          chartName="Risk by Threat"
          xAccessor={xAccessor}
          x1Accessor={x1Accessor}
          yMaxStackVal={systemOverviewTotalCharts.yMaxStackVal}
          data={systemOverviewTotalCharts.threatIRTab}
          dataKeys={systemOverviewTotalCharts.threatIRDataKeys}
          annotationsValues={systemOverviewTotalCharts.totals}
        />
      </ChartCard>
      <ChartCard
        loading={systemOverviewTotalCharts.loading}
        heading={<InterventionCardHeading heading="Risk by Consequence" />}
      >
        <StackedGroupBarChart
          {...baseBarChartProps}
          chartName="Risk by Consequence"
          xAccessor={xAccessor}
          x1Accessor={x1Accessor}
          yMaxStackVal={systemOverviewTotalCharts.yMaxStackVal}
          data={systemOverviewTotalCharts.consequenceIRTab}
          dataKeys={systemOverviewTotalCharts.consequenceIRDataKeys}
          annotationsValues={systemOverviewTotalCharts.totals}
        />
      </ChartCard>
      <ChartCard
        loading={systemOverviewTotalCharts.loading}
        heading={<InterventionCardHeading heading="Risk by Outcome Scenario" />}
      >
        <StackedGroupBarChart
          {...baseBarChartProps}
          chartName="Risk by Outcome Scenario"
          xAccessor={xAccessor}
          x1Accessor={x1Accessor}
          yMaxStackVal={systemOverviewTotalCharts.yMaxStackVal}
          data={systemOverviewTotalCharts.outcomeIRTab}
          dataKeys={systemOverviewTotalCharts.outcomeIRDataKeys}
          annotationsValues={systemOverviewTotalCharts.totals}
        />
      </ChartCard>
      <TopRiskWellsByThreatIntervention />
    </ChartsLayout>
  );
};

export default SystemOverviewInterventionCharts;
